import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import path from "./paths";
import {
  Home,
  Courses,
  Login,
  Dashboard,
  TheCourses,
  Classes,
  Students,
  TheTeachers,
  Requests,
  RequestDetails,
  TheScheduledCourses,
  Schedule,
  AboutUs,
  ContactUs,
  PageNotFound,
  Workshops,
  WorkshopDetails,
  CourseDetail,
  ClassDetail,
  ClassDetailsFindById,
  MyStudents,
  ClassesStudents,
  PaymentsAndInvoices,
  PermissionsAndRoles,
  ClassAssignments,
  ClassAssignment
} from "./lazy";
import ProtectedRoutes from "./ProtectedRoutes";
import { Fragment } from "react";
import Loading from "../../componenets/system/tools/Loading";

const Routings = () => {
  return (
    <>
      <Suspense
        fallback={
          <div className="suspense-loading">
            <div>Loading..</div>
            <div>
              <Loading
                img={"loading-circular"}
                width={"44px"}
                height={"44px"}
              />
            </div>
          </div>
        }
      >
        <Fragment>
          <Routes>
            <Route path={"/"} element={<Home />} />
            <Route path={path.home} element={<Home />} />
            <Route path={path.courses} element={<Courses />} />
            <Route
                exact
                path={path["class-details-find"]}
                element={<ClassDetailsFindById />}
              />
            <Route path={path["about-us"]} element={<AboutUs />} />
            <Route path={path["contact-us"]} element={<ContactUs />} />
            <Route path={path.login} element={<Login />} />
            <Route exact path={path.dashboard} element={<ProtectedRoutes />}>
              <Route exact path={path.dashboard} element={<Dashboard />} />
            </Route>
            <Route
              exact
              path={path["the-courses"]}
              element={<ProtectedRoutes />}
            >
              <Route
                exact
                path={path["the-courses"]}
                element={<TheCourses />}
              />
              <Route
                exact
                path={path["course-details"]}
                element={<CourseDetail />}
              />
            </Route>
            <Route exact path={path.classes} element={<ProtectedRoutes />}>
              <Route exact path={path.classes} element={<Classes />} />
              <Route
                exact
                path={path["class-details"]}
                element={<ClassDetail />}
              />
              <Route
                exact
                path={path["class-assignments"]}
                element={<ClassAssignments />}
              />
              <Route
                exact
                path={path["class-assignment"]}
                element={<ClassAssignment />}
              />
            </Route>
            <Route exact path={path.workshops} element={<ProtectedRoutes />}>
              <Route exact path={path.workshops} element={<Workshops />} />
            </Route>
            <Route exact path={path["workshop-details"]} element={<ProtectedRoutes />}>
              <Route exact path={path["workshop-details"]} element={<WorkshopDetails />} />
            </Route>
            <Route exact path={path.students} element={<ProtectedRoutes />}>
              <Route exact path={path.students} element={<Students />} />
            </Route>
            <Route
              exact
              path={path["the-teachers"]}
              element={<ProtectedRoutes />}
            >
              <Route
                exact
                path={path["the-teachers"]}
                element={<TheTeachers />}
              />
            </Route>
            <Route
              exact
              path={path["the-scheduled-courses"]}
              element={<ProtectedRoutes />}
            >
              <Route
                exact
                path={path["the-scheduled-courses"]}
                element={<TheScheduledCourses />}
              />
            </Route>
            <Route exact path={path.requests} element={<ProtectedRoutes />}>
              <Route exact path={path.requests} element={<Requests />} />
            </Route>
            <Route
              exact
              path={path["request-details"]}
              element={<ProtectedRoutes />}
            >
              <Route
                exact
                path={path["request-details"]}
                element={<RequestDetails />}
              />
            </Route>
            <Route exact path={path["schedule"]} element={<ProtectedRoutes />}>
              <Route exact path={path["schedule"]} element={<Schedule />} />
            </Route>
            <Route exact path={path["my-students"]} element={<ProtectedRoutes />}>
              <Route exact path={path["my-students"]} element={<MyStudents />} />
            </Route>
            <Route exact path={path["classes-students"]} element={<ProtectedRoutes />}>
              <Route exact path={path["classes-students"]} element={<ClassesStudents />} />
            </Route>
            <Route exact path={path.payments} element={<ProtectedRoutes />}>
              <Route exact path={path.payments} element={<PaymentsAndInvoices />} />
            </Route>
            <Route exact path={path["permissions-roles"]} element={<ProtectedRoutes />}>
              <Route exact path={path["permissions-roles"]} element={<PermissionsAndRoles />} />
            </Route>
            <Route path={path["*"]} element={<PageNotFound />} />
          </Routes>
        </Fragment>
      </Suspense>
    </>
  );
};

export default Routings;
